/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost
 */
export interface BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost {
    /**
     * 
     * @type {string}
     * @memberof BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost
     */
    feedProtobufContent: string;
    /**
     * 
     * @type {string}
     * @memberof BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost
     */
    anonymousUserId: string;
    /**
     * 
     * @type {string}
     * @memberof BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost
     */
    uploadMode: string;
    /**
     * 
     * @type {string}
     * @memberof BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost
     */
    xTtLogid: string;
    /**
     * 
     * @type {string}
     * @memberof BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost
     */
    sessionId: string;
}

/**
 * Check if a given object implements the BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost interface.
 */
export function instanceOfBodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost(value: object): value is BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost {
    if (!('feedProtobufContent' in value) || value['feedProtobufContent'] === undefined) return false;
    if (!('anonymousUserId' in value) || value['anonymousUserId'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('uploadMode' in value) || value['uploadMode'] === undefined) return false;
    if (!('xTtLogid' in value) || value['xTtLogid'] === undefined) return false;
    if (!('sessionId' in value) || value['sessionId'] === undefined) return false;
    return true;
}

export function BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPostFromJSON(json: any): BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost {
    return BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPostFromJSONTyped(json, false);
}

export function BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPostFromJSONTyped(json: any, ignoreDiscriminator: boolean): BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost {
    if (json == null) {
        return json;
    }
    return {
        
        'feedProtobufContent': json['feed_protobuf_content'],
        'anonymousUserId': json['anonymous_user_id'],
        'country': json['country'],
        'uploadMode': json['upload_mode'],
        'xTtLogid': json['x_tt_logid'],
        'sessionId': json['session_id'],
    };
}

export function BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPostToJSON(json: any): BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost {
    return BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPostToJSONTyped(json, false);
}

export function BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPostToJSONTyped(value?: BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'feed_protobuf_content': value['feedProtobufContent'],
        'anonymous_user_id': value['anonymousUserId'],
        'country': value['country'],
        'upload_mode': value['uploadMode'],
        'x_tt_logid': value['xTtLogid'],
        'session_id': value['sessionId'],
    };
}

